import * as React from "react";

import styled from "../../theme/styled";
import {
  colourHelper,
  fontLineHeightHelper,
  fontSizeHelper,
  fontWeightHelper
} from "../../theme/theme-helper";
import { HalfColumnWidthWrapper } from "../confines-wrappers";
import Wysiwyg from "../wysiwyg";
import {
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphWsywigWrapper {
  className: string;
  type: IFieldTechnicalArticleColumnType;
}

const ParagraphWsywigWrapper = styled<IParagraphWsywigWrapper>(
  HalfColumnWidthWrapper
)`
  h2,
  h3,
  h4,
  p,
  ul,
  ol {
    margin: 0;
    padding: 0;
  }

  h2,
  h3,
  h4 {
    padding-top: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "default"
    })};
    font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "subhead_1"
    })};
    font-weight: ${({ theme }) => fontWeightHelper({
    theme,
    variant: "bold"
  })};
  }

  h2 {
    font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "subhead_1"
    })};
  }

  h3 {
    font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_2"
  })};
  }

  h4 {
    font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_1"
  })};
  }

  blockquote {
    position: relative;
    padding-top: 2.4rem;
    padding-left: 16%;

    .speech-mark {
      display: flex;
      justify-content: center;
      position: absolute;
      top: 2.4rem;
      left: 0;
      width: 16%;

      .icon {
        fill: ${({ theme }) => colourHelper({
    theme,
    variant: "brandColor"
  })};
      }
    }

    .speech-mark + * {
      padding-top: 1rem;
    }
  }

  p,
  ul,
  ol {
    padding-top: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "default"
    })};
    font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_1"
  })};
    font-weight: ${({ theme }) =>
    fontWeightHelper({
      theme,
      variant: "light"
    })};
    line-height: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "large"
    })};

    strong {
      font-weight: ${({ theme }) =>
    fontWeightHelper({
      theme,
      variant: "bold"
    })};
    }

    code {
      font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier,
        monospace;
      padding: 0.2em 0.4em !important;
      font-size: 0.85em;
      // background-color: rgba(27, 31, 35, 0.05);
      background-color: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "lightestGrey"
    })};
      border-radius: 3px;
    }
  }

  ul,
  ol {
    padding-left: 2.8rem;
  }

  *:first-child {
    padding-top: 0;
  }

  @media (min-width: 568px) {
    blockquote {
      padding-left: 10%;

      .speech-mark {
        width: 10%;
      }

      .speech-mark + * {
        padding-top: 1rem;
      }
    }
  }

  @media (min-width: 600px) {
    h2 {
      font-size: ${props =>
    props.type === "basic" ?
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "subhead_1"
      }) :
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "subhead_2"
      })};
    }

    h3 {
      font-size: ${props =>
    props.type === "basic" ?
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "body_2"
      }) :
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "subhead_1"
      })};
    }

    h4 {
      font-size: ${props =>
    props.type === "basic" ?
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "body_1"
      }) :
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "body_2"
      })};
    }

    p,
    ul,
    ol {
      font-size: ${props =>
    props.type === "basic" ?
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "body_1"
      }) :
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "body_2"
      })};
    }
  }

  @media (min-width: 960px) {
    h2 {
      font-size: ${props =>
    props.type === "basic" ?
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "subhead_2"
      }) :
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "subhead_3"
      })};
    }

    h3 {
      font-size: ${props =>
    props.type === "basic" ?
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "subhead_1"
      }) :
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "body_2"
      })};
    }

    h4 {
      font-size: ${props =>
    props.type === "basic" ?
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "body_2"
      }) :
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "subhead_1"
      })};
    }

    p,
    ul,
    ol {
      font-size: ${props =>
    props.type === "basic" ?
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "body_2"
      }) :
      ({ theme }) => fontSizeHelper({
        theme,
        variant: "subhead_1"
      })};
    }
  }
`;

const ParagraphWsywig = ({ type, content }: IProps) => {
  return (
    <ParagraphWsywigWrapper
      className="paragraph-wysiwyg"
      type={type}
    >
      <Wysiwyg
        type="formatted"
        content={content.field_copy!.processed}
      />
    </ParagraphWsywigWrapper>
  );
};

export default ParagraphWsywig;
